import React from 'react';
import PropTypes from 'prop-types';
import { ColorSwatchIcon, ColorPicker } from '@pearsontechnology/aero-components';
import { InputWrapper, ColorDropDown, InputLabel } from './styles';

export function hexToObject(hex) {
  if (hex.length < 6) {
    return { r: 0, g: 0, b: 0, a: 0 };
  }

  const rawHex = (hex[0] === '#') ? hex.substring(1) : hex;
  return {
    r: parseInt(rawHex.substr(0, 2), 16) || 0,
    g: parseInt(rawHex.substr(2, 2), 16) || 0,
    b: parseInt(rawHex.substr(4, 2), 16) || 0,
    a: 1,
  };
}

export default function SimpleColorInput({
  label,
  defaultValue,
  onChange,
  ...props
}) {
  return (
    <InputWrapper>
      { label && <InputLabel>{label}</InputLabel>}
      <ColorDropDown
        grey
        value={<ColorSwatchIcon color={defaultValue} />}
        {...props}
      >
        {() => (
          <ColorPicker
            color={hexToObject(defaultValue)}
            onChangeComplete={(value) => { onChange(value.hex); }}
          />
        )}
      </ColorDropDown>
    </InputWrapper>
  );
}

SimpleColorInput.propTypes = {
  label: PropTypes.any,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
};
